import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ConstraintDetail from './ConstraintDetail';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
export default class ListConstraints extends Component {
  static propTypes = {
    constraints: PropTypes.array.isRequired,
    projectId: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
    collection: PropTypes.object.isRequired,
  };

  state = {
    activeConstraint: '',
  };

  activateConstraint = (name) => {
    if (this.state.activeConstraint === name) {
      this.setState({ activeConstraint: '' });
    } else {
      this.setState({ activeConstraint: name });
    }
  };

  showConstraintValue = (constraintType, fields) => {
    if (constraintType === 'COMPOSITE') {
      return fields.map((field) => field.label).join(', ');
    }
    return value;
  };

  handleDelete = (uuid) => {
    this.props.handleDelete(uuid);
  };

  showConstraintsDetail = (constraint) => {
    const {
      projectId,
      collection,
      actions,
      commonActions,
      version,
      showDerivedConstraintLoader,
      showConstraintDeleteLoader,
      deleteFlag,
    } = this.props;
    return (
      <AccordionItem key={constraint.name}>
        <AccordionItemHeading>
          <AccordionItemButton>
            <i className={`wb`}></i> <strong>{constraint.name}</strong>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <ConstraintDetail
            projectId={projectId}
            collection={collection}
            version={version}
            actions={actions}
            commonActions={commonActions}
            showConstraintValue={this.showConstraintValue}
            constraint={constraint}
            showDerivedConstraintLoader={showDerivedConstraintLoader}
            showConstraintDeleteLoader={showConstraintDeleteLoader}
            deleteFlag={deleteFlag}
          />
        </AccordionItemPanel>
      </AccordionItem>
    );
  };

  render() {
    const { constraints } = this.props;
    if (constraints && constraints.length > 0) {
      return (
        <div className="row modal-scroll">
          <div className="col-12">
            <Accordion allowZeroExpanded>
              {constraints.map((constraint) => this.showConstraintsDetail(constraint))}
            </Accordion>
          </div>
        </div>
      );
    }
    return (
      <div>
        <h5 className="text-center">No Constraints!</h5>
      </div>
    );
  }
}
